<template>
  <div class="container-fluid">
    <div class="row justify-content-center">
      <div class="col-12">
        <addHeader
          :title="$t('Add WhatsApp')"
          :description="$t('From here you can control adding WhatsApp')"
        />
        <div class="row">
          <formInput :title="$t('wrench')" v-model="item.api_key" maxlength="255" />
          <formInput
            :title="$t('alert number')"
            v-model="item.notification_number"
            maxlength="255"
          />
          <formInput :title="$t('StateKey')" v-model="item.country_key" maxlength="255" />
        </div>
        <dvider
          :title="$t('Whatsapp message information')"
          :description="$t('Basic information for WhatsApp messages')"
        />
        <div class="mt-5">
          <formTextarea :title="$t('Quote text')" v-model="item.quotation_text" />
          <formTextarea :title="$t('Sales invoice text')" v-model="item.invoice_text" />
          <formTextarea :title="$t('Text of purchase invoices')" v-model="item.bill_text" />
          <formTextarea :title="$t('SaleReturnsText')" v-model="item.sales_return_text" />
          <formTextarea :title="$t('Purchase returns text')" v-model="item.purchase_return_text" />
          <formTextarea :title="$t('SalesChequeText')" v-model="item.sales_chque_text" />
          <formTextarea
            :title="$t('Text of purchase checques')"
            v-model="item.purchase_chque_text"
          />
          <formTextarea :title="$t('Sale discount text')" v-model="item.sales_discount_text" />
          <formTextarea
            :title="$t('Text purchase discounts')"
            v-model="item.purchase_discount_text"
          />
        </div>
        <hr class="mt-5 mb-5 col-12" />
        <a class="btn btn-block btn-primary mb-3">
          {{ $t('save edit') }}
        </a>
        <a class="btn btn-block btn-primary mb-3" v-if="false">
          {{ $t('save edit') }}
        </a>
        <loading v-if="$parent.stopEdit" />
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import formInput from '@/elements/add/form/formInput.vue'
import formTextarea from '@/elements/add/form/formTextarea.vue'
import addHeader from '@/elements/add/header.vue'
import loading from '@/elements/add/loading.vue'
import dvider from '@/elements/add/dvider.vue'

export default {
  data() {
    return {
      path: '/applications',
      item: {},
      errors: {
        name: false,
        rate: false
      }
    }
  },
  components: {
    formInput,
    dvider,
    addHeader,
    loading,
    formTextarea
  }
}
</script>
